import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { Text } from '@/design-system/atoms/Text';
import { formatTime } from '@/utils/formatTime';

import styles from './AudioListItem.module.scss';

const AudioTimeDisplay = (props) => {
    const { titleTruncation, currentTime, duration } = props;

    return (
        <div className={classnames(styles[`audio__time-display`])}>
            <Text
                tag="span"
                variant={Text.VARIANT.T3}
                content={formatTime(currentTime)}
                lineClamp={titleTruncation ? titleTruncation : null}
                allowInlineHTML
            />
            <Text
                tag="span"
                variant={Text.VARIANT.T3}
                content={'/'}
                lineClamp={titleTruncation ? titleTruncation : null}
                allowInlineHTML
            />
            <Text
                tag="span"
                variant={Text.VARIANT.T3}
                content={formatTime(duration)}
                lineClamp={titleTruncation ? titleTruncation : null}
                allowInlineHTML
            />
        </div>
    );
};

AudioTimeDisplay.propTypes = {
    /**
     * Audio total time
     */
    duration: PropTypes.number,
    /**
     * Audio current time
     */
    currentTime: PropTypes.number,
    /**
     * Optional title truncation for the link list item
     */
    titleTruncation: PropTypes.shape({ sm: PropTypes.number, lg: PropTypes.number }),
};

export default AudioTimeDisplay;
